import React                 from 'react';
 import { connect }          from 'react-redux';
//import { Dispatch }          from "redux";
import { reducerType }       from 'reducer';
//import { ActionTypes }       from 'actions/types'; 
import box_1                 from 'images/box_1.png';
import box_2                 from 'images/box_2.png';
import box_3                 from 'images/box_3.png';
import box_4                 from 'images/box_4.png';
import box_5                 from 'images/box_5.png';
import box_6                 from 'images/box_6.png';
import box_7                 from 'images/box_7.png';
import box_8                 from 'images/box_8.png';
import box_9                 from 'images/box_9.png';
import closedBox             from 'images/closedBox.png';
import { makeStyles/* , theme */ } from "makeStyles";
import { componentsStateType, modalStateType } from 'reducer/types';

var clsx = require('classnames')

const useStyles = makeStyles()(
    (theme) => ({
    root : {
        height:              '90%',
        width:               '90%',
        marginLeft:          '5%',
        marginTop:           '5%',
        marginBottom:        15,
        display:             'grid',
        gridTemplateColumns: `repeat(4, 1fr)`,
        columnGap:           15,
        rowGap:              15,

    },
    item: {
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    },
    closedBox: {
      backgroundImage: `url(${ closedBox })`
    },
    noImage: {
      backgroundImage: `none`,
    }
}))


type EggBoxGridType = {
    question:        number;
    componentsState: componentsStateType;
    modalState:      modalStateType;
}

const EggBoxGrid: React.FC<EggBoxGridType> = ({ 
  question,
  componentsState,
  modalState
}) => {

  const { classes } = useStyles();

  const [arrLength, unitImage, rootStyle] = React.useMemo(() => {

    let unitsVal = componentsState.units.value === -1 ? 0 : componentsState.units.value;
    let tensVal  = componentsState.tens.value === -1 ? 0 : componentsState.tens.value;
    
    if ( modalState.modalVariant === 'showTensMazeget') {
      unitsVal = 7
      tensVal  = 3
    }

    const variant  = modalState.modalVariant === 'showTensInput' ? 'input' : 'dnd';
    const totalVal = ((tensVal * 10) + unitsVal);
    const columns  = question <= 10 ? 1 : 3;
    const unit     = variant === 'input' ? (Math.floor(question/10)) : (Math.floor(totalVal/10));
    const image    = variant === 'input' ? question%10 : totalVal%10;


    return[
      ((!!unit && unit > 0) ? unit : 0),
      ['',box_1,box_2,box_3,box_4,box_5,box_6,box_7,box_8,box_9][image], 
      {
        gridTemplateColumns: `repeat(${ columns }, 1fr)`,
      }
    ]
    

  },[question, modalState, componentsState])

  return(
    <div 
       className = { classes.root }
       style     = { rootStyle }
    >
       {
         new Array(arrLength).fill(0).map((val, ind) => {
           return(
             <div
               key       = { `boxImage${ ind }__` }
               className = { clsx(classes.item, classes.closedBox) }
             />
           )
         })
       }
       <div
          className = { classes.item }
          style     = {{ backgroundImage: `url(${ unitImage })` }}
       />
    </div>
  )

}


const mapStateToProps = (reducer: reducerType) => {
  return {
     componentsState: reducer.components,
     modalState:      reducer.modal
}};
  
export default connect(mapStateToProps)(EggBoxGrid);
  
  